<div
  #saysoPreviewContainer
  class="mobile-preview-container"
  [class.left]="buttonLocation === 'left'"
  [class.right]="buttonLocation === 'right'"
>
  <onsip-mobile-preview-frame-image [width]="width"></onsip-mobile-preview-frame-image>
  <div class="content-container">
    <div class="popup-container">
      <div class="sayso-preview sayso-preview-transition" [class.exited]="!openMobilePreview">
        <div class="content">
          <ng-content></ng-content>
        </div>
        <div class="sayso-preview-footer">
          @if (!removedOnsipBranding) {
          <p><strong>sayso</strong> {{ "ONSIP_I18N.BY" | translate }} OnSIP</p>
          } @if (openMobilePreview) {
          <button class="sayso-close-button" (click)="handleMobileClick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="5 5 14 14">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path
                d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
              />
            </svg>
          </button>
          }
        </div>
      </div>
    </div>
    <div class="button-container">
      <!-- <div class="label-container" [class.exited]="openMobilePreview">
      <div class="label">
        <span>Talk to a real person, right now</span>
      </div>
    </div> -->
      @if (!openMobilePreview) {
      <button
        mat-fab
        onsip-sayso-fab
        (click)="handleMobileClick()"
        [style.background-color]="buttonColor"
        [style.color]="buttonColor | textColorForCustomBackground"
        [class.gradient]="gradientOverlay"
      >
        <mat-icon>phone</mat-icon>
      </button>
      }
    </div>
  </div>
</div>
